
import moment from 'moment'

export default {
  computed: {
    translations () {
      return this.$store.state.translations
    },
    availableLocales () {
      return Object.keys(this.translations)
    },
    locales () {
      return this.availableLocales.map(locale => ({
        value: locale,
        text: this.translations[locale].locale,
      }))
    },
  },

  methods: {
    changeLocale (locale) {
      if (this.availableLocales.indexOf(locale) === -1) {
        return false
      }
      localStorage.setItem('locale', locale)
      this.$store.commit('locale', locale)
      moment.locale(locale)
      this.$vuetify.lang.current = locale
      this.$log('Changed locale to ' + locale.toUpperCase())
      return true
    },
  },
}
